import React, { useState } from "react";
import "./ContactForm.css";
import Loading from "../loading/Loading";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    startDate: "",
    endDate: "",
    address: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const accessKey = "9c261127-53cb-4949-9727-30cac22a73eb";

  //     if (!accessKey) {
  //       throw new Error(
  //         "VITE_WEB3FORMS_ACCESS_KEY is missing from the environment variables.",
  //       );
  //     }

  //     const web3FormData = new FormData();

  //     web3FormData.append("access_key", accessKey);

  //     web3FormData.append("subject", formData.subject || "New Contact Inquiry");

  //     web3FormData.append("from_name", "Twin Travel Coron Website");

  //     web3FormData.append("replyto", formData.email);

  //     web3FormData.append("name", formData.name);

  //     web3FormData.append("email", formData.email);

  //     web3FormData.append("contactNumber", formData.contactNumber);

  //     web3FormData.append("startDate", formData.startDate);

  //     web3FormData.append("endDate", formData.endDate);

  //     web3FormData.append("address", formData.address);

  //     web3FormData.append("message", formData.message);

  //     const response = await fetch("https://api.web3forms.com/submit", {
  //       method: "POST",
  //       body: web3FormData,
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       alert("Your inquiry has been sent!");

  //       setFormData({
  //         name: "",
  //         email: "",
  //         contactNumber: "",
  //         startDate: "",
  //         endDate: "",
  //         address: "",
  //         subject: "",
  //         message: "",
  //       });
  //     } else {
  //       console.error("Web3Forms Error:", data);

  //       alert(data.message || "Failed to send inquiry. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);

  //     alert("Something went wrong. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const accessKey = "9c261127-53cb-4949-9727-30cac22a73eb";

      const web3FormData = new FormData();

      web3FormData.append("access_key", accessKey);
      web3FormData.append("subject", formData.subject || "New Contact Inquiry");
      web3FormData.append("from_name", "Twin Travel Coron Website");
      web3FormData.append("replyto", formData.email);
      web3FormData.append("name", formData.name);
      web3FormData.append("email", formData.email);
      web3FormData.append("contactNumber", formData.contactNumber);
      web3FormData.append("startDate", formData.startDate);
      web3FormData.append("endDate", formData.endDate);
      web3FormData.append("address", formData.address);
      web3FormData.append("message", formData.message);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: web3FormData,
      });

      const data = await response.json();

      if (data.success) {
        alert("Your inquiry has been sent!");

        setFormData({
          name: "",
          email: "",
          contactNumber: "",
          startDate: "",
          endDate: "",
          address: "",
          subject: "",
          message: "",
        });
      } else {
        console.error("Web3Forms Error:", data);

        alert(data.message || "Failed to send inquiry. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="contactUsMainCont">
      <div className="contact-container">
        <h2>Contact Us</h2>

        {loading ? (
          <Loading />
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <input
              type="tel"
              name="contactNumber"
              placeholder="Contact Number"
              value={formData.contactNumber}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <div className="date-fields">
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                min={today}
                required
                disabled={loading}
              />

              <input
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                min={formData.startDate || today}
                required
                disabled={loading}
              />
            </div>

            <input
              type="text"
              name="address"
              placeholder="Address"
              value={formData.address}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject of Inquiry"
              value={formData.subject}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              disabled={loading}
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Inquiry"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactForm;
